/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    JiraStatusSyncReverseStatusMapping,
    JiraStatusSyncReverseStatusMappingFromJSON,
    JiraStatusSyncReverseStatusMappingToJSON,
    JiraStatusSyncStatusMapping,
    JiraStatusSyncStatusMappingFromJSON,
    JiraStatusSyncStatusMappingToJSON,
} from './';

/**
 * 
 * @export
 * @interface JiraStatusSync
 */
export interface JiraStatusSync {
    /**
     * 
     * @type {Array<JiraStatusSyncStatusMapping>}
     * @memberof JiraStatusSync
     */
    statusMapping?: Array<JiraStatusSyncStatusMapping>;
    /**
     * 
     * @type {Array<JiraStatusSyncReverseStatusMapping>}
     * @memberof JiraStatusSync
     */
    reverseStatusMapping?: Array<JiraStatusSyncReverseStatusMapping>;
}

export function JiraStatusSyncFromJSON(json: any): JiraStatusSync {
    return {
        
        'statusMapping': !exists(json, 'statusMapping') ? undefined : (json['statusMapping'] as Array<any>).map(JiraStatusSyncStatusMappingFromJSON),
        
        
        'reverseStatusMapping': !exists(json, 'reverseStatusMapping') ? undefined : (json['reverseStatusMapping'] as Array<any>).map(JiraStatusSyncReverseStatusMappingFromJSON),
        
    };
}

export function JiraStatusSyncToJSON(value?: JiraStatusSync): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'statusMapping': value.statusMapping === undefined ? undefined : (value.statusMapping as Array<any>).map(JiraStatusSyncStatusMappingToJSON),
        
        
        'reverseStatusMapping': value.reverseStatusMapping === undefined ? undefined : (value.reverseStatusMapping as Array<any>).map(JiraStatusSyncReverseStatusMappingToJSON),
        
    };
}


